export default __webpack_public_path__ + "static/EYInterstateLight-bacb86997e9d9fe34fe8480ec21b7400.woff2";